<template>
  <div class="pt-4">
    <layout-no-padding>
      <v-flex xs6 v-for="(resource) in resources" :key="resource.id">
        <div class="box pa-2">
          <v-icon>picture_in_picture_alt</v-icon>
          <div>{{getModelLabel(resource.type)}}</div>
        </div>
      </v-flex>
    </layout-no-padding>
  </div>
</template>

<script>
import models from "./mixins/models";
export default {
  mixins: [models],
  props: {
    resources: Array,
    model: String
  },
  methods: {
    getModelLabel(resourceType) {
      const model = this.models.filter(mod => mod.value == this.model)[0];
      return model.resourceTypes.filter(type => type.value == resourceType)[0]
        .text;
    }
  },
  mounted() {
    console.log(this.resources);
  }
};
</script>

<style>
.box {
  border-radius: 5px;
  border: solid 1px rgba(0, 0, 0, 0.2);
}
</style>